module dg.objects {
    


    export class DateDisplayerController extends PropertyDisplayerControllerBase <string> {
        public constructor(
            private $filter: ng.IFilterService,
            private dateService : DateService
        ) {
            super();
        }

        public dateFormat: string;
        public formattedValue: string;

        protected init() {
            this.dateFormat = this.dateService.getFormat(this.propMeta.dataType);
            this.recalculateValue();
        }

        $onChanges = (c) => {
            
            if (c.value && this.propMeta) {
                this.recalculateValue();
            }
        }

        private recalculateValue() {
            if (this.propMeta["UTC"]) {
                this.formattedValue = this.$filter('date')(this.value, this.dateFormat, 'UTC');
            }
            else {
                this.formattedValue = this.$filter('date')(this.value, this.dateFormat);
            }
        }
    }

    dg.objects.AngularHelper.registerPropertyDisplayer(DateDisplayerController, 'dateDisplayer', {
        template: '<span ng-bind="$ctrl.formattedValue"></span>'
    });
}
